<div class="login-page">

  <video #videoPlayer
    autoplay
    loop
    muted
    playsinline
    class="video-bg">
    <source src="/assets/img/videos/graoully.mp4" type="video/mp4">
  </video>

  <div class="overlay"></div>

  <div class="login-container">
    <div class="login-card">
      <div [ngSwitch]="form">
        <gob-log-form
          *ngSwitchCase="FORM_LOGIN"
          (signup)="this.form=FORM_SIGNUP"
          (forgot)="this.form=FORM_FORGOT">
        </gob-log-form>

        <gob-sign-form
          *ngSwitchCase="FORM_SIGNUP"
          (login)="this.form=FORM_LOGIN">
        </gob-sign-form>

        <gob-forgot-form
          *ngSwitchCase="FORM_FORGOT"
          (login)="this.form=FORM_LOGIN">
        </gob-forgot-form>
      </div>
    </div>
  </div>

</div>
